import React from 'react';

import { Button } from 'components';

// Context
import { useWidgetTableContext } from 'components/machine-health';

// Types
import { WidgetTableDataItem } from 'types/machine-health';
import { UploadTagsImageData } from '../WidgetTable/WidgetTableContext';

interface SaveButtonProps {
  saveCallBack: (data: WidgetTableDataItem[], imageData?: UploadTagsImageData[]) => void;
  isDirty: boolean;
}

const SaveButton = ({ isDirty, saveCallBack }: SaveButtonProps): JSX.Element => {
  const { localTableRows, uploadTagsImage } = useWidgetTableContext();

  return (
    <Button
      disabled={!isDirty}
      variant={'primary'}
      width="5.25rem"
      onClick={() => saveCallBack(localTableRows, uploadTagsImage)}
    >
      Save
    </Button>
  );
};

export default SaveButton;
